window.competitionsBanner = () => {
    return{
        countDownDate: null,
        timer: null,

        init(){
            this.countDownDate = new Date(this.$refs.competitionContainer.dataset.closingDate).getTime();
            this.timer = this.$refs.competitionContainer.getElementsByClassName('timer')[0];
            this.countDown();
            setInterval(() => {
                this.countDown()
            }, 10000);
        },
        countDown(timer){
            // Get today's date and time
            let now = new Date().getTime();

            // Find the distance between now and the count down date
            let distance = this.countDownDate - now;

            // Time calculations for days, hours, minutes and seconds
            let days = Math.floor(distance / (1000 * 60 * 60 * 24));
            let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

            const timerContainer = this.timer;

            // Display the result in the element with id="demo"
            timerContainer.innerHTML = days.toString().padStart(2, '0') + " : " + hours.toString().padStart(2, '0') + " : "
                + minutes.toString().padStart(2, '0');

            // If the count down is finished, write some text
            if (distance < 0) {
                clearInterval(x);
                timerContainer.innerHTML = "EXPIRED";
            }
        }
    }
}